import styled from 'styled-components';
import { RadioGroupSwitcher } from '@landlord-tech/ui-kit-opp/dist/components/RadioGroupSwitcher';

const SRadioGroupSwitcher = styled(RadioGroupSwitcher)`
  &&& {
  }
`;

export default SRadioGroupSwitcher;
